import baseURL from '../common/axios';
class CustomerBranchMappingservices {

    insert(dataModel) {
        return baseURL.httpMSInventoryUrl.post("CustomerBranchMapping/Create", dataModel)
    }
    update(dataModel) {
        return baseURL.httpMSInventoryUrl.post("CustomerBranchMapping/Update", dataModel)
    }
    delete(Id) {
        return baseURL.httpMSInventoryUrl.delete("CustomerBranchMapping/Delete?id=" + Id)
    }
    //Active
    active(Id, Status) {
        return baseURL.httpMSInventoryUrl.put("CustomerBranchMapping/Active?id=" + Id + "&Status=" + Status + "")
    }
    getById(Id) {
        return baseURL.httpMSInventoryUrl.get("CustomerBranchMapping/Get?CustomerId=" + Id)
    }

}
export default new CustomerBranchMappingservices()